module.exports = __webpack_public_path__ + "img/unlock.0d9c7ecf.svg";